import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/canada.geojson";

const PROVINCES = [
    { code: "Alberta", name: "Alberta" },
    { code: "British Columbia", name: "British Columbia" },
    { code: "Manitoba", name: "Manitoba" },
    { code: "New Brunswick", name: "New Brunswick" },
    { code: "Newfoundland and Labrador", name: "Newfoundland and Labrador" },
    { code: "Northwest Territories", name: "Northwest Territories" },
    { code: "Nova Scotia", name: "Nova Scotia" },
    { code: "Nunavut", name: "Nunavut" },
    { code: "Ontario", name: "Ontario" },
    { code: "Prince Edward Island", name: "Prince Edward Island" },
    { code: "Quebec", name: "Quebec" },
    { code: "Saskatchewan", name: "Saskatchewan" },
    { code: "Yukon Territory", name: "Yukon Territory" }
];

const PROVINCE_CODES = PROVINCES.map(p => p.code);
const ITEMS = PROVINCES.map(p => ({ id: p.code, name: p.name }));

const CanadaMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoAzimuthalEqualArea"
            projectionConfig={{
                scale: 800,
                center: [0, 2],
                rotate: [96, -60, 0]
            }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => PROVINCE_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const provinceName = geo.properties.name;
                            const isVisited = visited.includes(provinceName);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(provinceName)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="canada"
            analyticsLocationType="canadian_province"
            trackingLabel="Canada Map"
            storageKey="canada_map"
            title="🇨🇦 Canada Travel Map"
            subtitle="Click on provinces and territories you've visited, or use the checklist below!"
            items={ITEMS}
            noun="Provinces"
            unitLabel="provinces and territories"
            captionUnit="Canadian provinces and territories"
            share={{
                region: 'Canada',
                fileName: 'visited-canada-map.png',
                trackId: 'canada'
            }}
            renderMap={renderMap}
        />
    );
};

export default CanadaMapSection;
